import { buildModelManager } from "../builder.js";
const DefaultIntentWeightConfigSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  createdBy: true,
  kFactors: true,
  notes: true,
  thresholds: true,
  updatedAt: true,
  version: true,
  weights: true
};
const modelApiIdentifier = "intent_weight_config";
const pluralModelApiIdentifier = "intent_weight_configs";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultIntentWeightConfigSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultIntentWeightConfigSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultIntentWeightConfigSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultIntentWeightConfigSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultIntentWeightConfigSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultIntentWeightConfigSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultIntentWeightConfigSelection,
    namespace: null
  }
];
const IntentWeightConfigManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultIntentWeightConfigSelection,
  operations
);
export {
  DefaultIntentWeightConfigSelection,
  IntentWeightConfigManager
};
//# sourceMappingURL=IntentWeightConfig.js.map
